module.exports = __webpack_public_path__ + "static/media/HCMM424.ae3abb67.jpg";